import axios from 'axios';
import * as CONFIG from '../config/index';
export const MASTER_DATA_API_URL = `${CONFIG.API_URL}/master-data`
export default {
    getByType: (type) => {
      return axios.get(`${MASTER_DATA_API_URL}/get-by-type?type=${type}`);
    },
    getByTypeAndCode: (type, code) => {
      return axios.get(`${MASTER_DATA_API_URL}/get-by-type-and-code?type=${type}&code=${code}`);
    },
    get: (id) => {
      return axios.get(`${MASTER_DATA_API_URL}/${id}`);
    },
    sync : {
      getByType: async (type) => {
        if (type) {
          let result = await axios.get(`${MASTER_DATA_API_URL}/get-by-type?type=${type}`);
          return result.data.data.items;
        } else {
          return [];
        }

      },
      getByTypeId: async (typeIds) => {
        let strTypes = '';
        if (Array.isArray(typeIds) && typeIds.length > 0) {
          strTypes = typeIds.join();
        } else {
          strTypes = typeIds;
        }
        if (typeIds) {
          let result = await axios.get(`${MASTER_DATA_API_URL}/get-by-type?typeIds=${strTypes}`);
          return result.data.data.items;
        } else {
          return [];
        }
      },
      get: async (id) => {
        let result = await axios.get(`${MASTER_DATA_API_URL}/${id}`);
        return result.data.data;
      },
      search: async (props, pageNo, pageSize) => {
        let code = props.code ? props.code : '';
        let name = props.name ? props.name : '';
        let type = props.type ? props.type : '';
        let types = props.types ? props.types : [];
        let strTypes = '';
        if (types.length > 0) {
          types.forEach(v => {
            strTypes = strTypes + v +',';
          })
          if (strTypes.length > 0) {
            strTypes = strTypes.substring(0, strTypes.length - 1);
          }
        }
        let result = await axios.get(`${MASTER_DATA_API_URL}/search?types=${strTypes}&code=${code}&name=${name}&type=${type}&pageNo=${pageNo}&pageSize=${pageSize}`);
        return result.data.data;
      },
      getByTypeAndCodeIn: async (type, code) => {
        let result = await axios.get(`${MASTER_DATA_API_URL}/get-by-type-and-codes?type=${type}&codes=${code.join()}`);
        return result.data.data;
      }
    }
}



// WEBPACK FOOTER //
// ./src/common/masterData.js